import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { ProductGroup, Product, ProductList } from "@/types/product";

const ProductsGroupService = new APIService<ProductGroup>(API.ProductGroup);
const ProductListService = new APIService<ProductList>(API.ProductList);
const ProductsService = new APIService<Product>(API.Products);

export const fetchProductGroupList = ProductsGroupService.getList;
export const fetchProductList = ProductListService.get;
export const fetchProducts = ProductsService.getList;
export const fetchProduct = ProductsService.get;
